'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewController = exports._getLineItemsContainerHeight = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _Overlay = require('components/Overlay2');

var _Overlay2 = _interopRequireDefault(_Overlay);

var _Remodal = require('../Remodal');

var _Remodal2 = _interopRequireDefault(_Remodal);

var _QuickView = require('../QuickView');

var _QuickView2 = _interopRequireDefault(_QuickView);

var _ConnectableObservable = require('rxjs/observable/ConnectableObservable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */

var InlineCart = {};

/*
  *  Dependency: <div class="overlay" data-overlay></div> in theme.liquid,
  *              components/_overlay.scss
  *
  *  Note: _overlay.scss hold the styles for the overlay container
  *  Note: .overlay has a z-index of 1000, so any modal that needs to appear on top
  *        of the overlay need to have an z-index of 1001+
  *
  *
  */

// Private inline functions
var lineItemEntryPoint = void 0;
var lineItemProperties = {};

var strapPromoActive = false;

var isFlow = function isFlow() {
  return Flow && Flow.cart && Flow.getExperience();
};

/**
 * @param {Boolean|undefinded} state  true --> visible, undefined --> toggle
 */
var toggleInlineCartVisibilityState = function toggleInlineCartVisibilityState(state) {

  if (typeof state !== 'boolean') {
    state = !$('[data-inline-cart]').hasClass('is-active');
  }

  console.log('state', state);

  if (state) {
    $('[data-inline-cart]').css('max-height', window.innerHeight - 55 + 'px').addClass('is-active');
    $('[data-inline-cart-header-trigger]').attr('aria-expanded', 'true');
    $('[data-inline-cart-close-button]').attr('aria-expanded', 'true');

    _Overlay2.default.enable();

    $(window).resize(function () {
      $('[data-inline-cart]').css('max-height', window.innerHeight - 55 + 'px');
      $('[data-cart-contents]').css('max-height', _getLineItemsContainerHeight());
    });

    $('.js-mobile-nav').removeClass('active');
  } else {
    $('[data-inline-cart]').removeClass('is-active');

    $('[data-inline-cart-header-trigger]').attr('aria-expanded', 'false');

    $('[data-inline-cart-close-button]').attr('aria-expanded', 'false');

    _Overlay2.default.disable();
  }

  $('[data-cart-contents]').css('max-height', _getLineItemsContainerHeight());
};

// Public inline functions
// international and domestic
InlineCart.getCartHtml = function () {
  $.get('/cart?view=contents', function (response) {
    lineItemEntryPoint.html(response);
    if (isFlow()) Flow.cart.localize();
  });

  $.get('/cart?view=subtotal', function (response) {
    $(':not([data-cart-page-summary]) [data-payment-summary]').replaceWith(response);
    $('[data-cart-page-summary] [data-payment-summary]').replaceWith(response.replace(/subtotal:/i, 'grand total:'));
    if (isFlow()) Flow.cart.localize();
  });
};

InlineCart.getCart = function () {
  var $cartFull = $('[data-full-cart]');
  var $cartEmpty = $('[data-empty-cart]');
  var $cartCount = $('[data-item-count]');
  var options = {
    success: function success(status, cart) {
      displayFlowCartPromoMessage(cart);
      var cartCount = cart.item_count;
      var cartTotal = cart.local.total_price.label;

      $('.cart-subtotal').text(cartTotal);
      $cartCount.text(cartCount);

      if (cartCount === 0) {
        $('.account-inline-cart').hide();
        $cartFull.css('display', 'none');
        $cartEmpty.css('display', 'block');
      } else {
        $('.variation-2 .account-inline-cart').show();
        $cartFull.css('display', 'block');
        $cartEmpty.css('display', 'none');
      }
      InlineCart.freeShipping(cart);

      if (window.dyCartUpsellTest) {
        // DY - INLINE CART UPSELL (FLOW)
        InlineCartRecs.serveUpsell(cart);
      }
    },
    error: function error(status, _error) {
      console.log(_error);
    }
  };

  $.getJSON('/cart.js', function (cart) {
    InlineCart.currentCart = cart;
    if (cart.item_count > 0) {
      // TODO use viewController
      $('.variation-2 .account-inline-cart').show();
      $('[data-account-drawer]').show();
      $('.shipping-header').show();
    } else {
      // TODO use viewController
      $('.account-inline-cart').hide();
      $('[data-account-drawer]').hide();
      $('.shipping-header').hide();
    }
    $cartCount.text(cart.item_count);
    // end inline cart account flow test

    // DY - INLINE CART UPSELL (DOMESTIC)
    InlineCartRecs.serveUpsell(cart);
  });
};

InlineCart.freeShipping = function (cart) {
  var availableGetFreeShippingPromotion = function availableGetFreeShippingPromotion() {
    var freeShippingPromotion = void 0;
    var availablePromotions = cart.local.promotions.available;

    for (var i = 0; i < availablePromotions.length; i += 1) {
      if (availablePromotions[i].discriminator === 'free_shipping') {
        freeShippingPromotion = availablePromotions[i];
      }
    }

    return freeShippingPromotion;
  };

  console.log('shipping', cart);

  var appliedGetFreeShippingPromotion = function appliedGetFreeShippingPromotion() {
    var freeShippingPromotion = void 0;
    var availablePromotions = cart.local.promotions.applied;

    for (var i = 0; i < availablePromotions.length; i += 1) {
      if (availablePromotions[i].discriminator === 'free_shipping') {
        freeShippingPromotion = availablePromotions[i];
      }
    }

    return freeShippingPromotion;
  };

  var availableFreeShipping = availableGetFreeShippingPromotion();
  var appliedFreeShipping = appliedGetFreeShippingPromotion();

  if (isFlow()) {
    if (availableFreeShipping) {
      $('.free-shippng-minimum').text(availableFreeShipping.trigger.min.label);
      $('.shipping-minimum').text(availableFreeShipping.trigger.remaining.label);
      $('.free-shipping-counter').show();
      $('.free-shipping').hide();
      $('.temp-remove-shipping-intl').hide();
    } else if (appliedFreeShipping) {
      $('.free-shippng-minimum').text(appliedFreeShipping.trigger.min.label);
      $('.free-shipping').show();
      $('.free-shipping-counter').hide();
      $('.temp-remove-shipping-intl').hide();
    }
  }
};

var getWarehouseProp = function getWarehouseProp(itemsArray) {
  var options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: {
      destination: flowSession.geo.country.iso_3166_3,
      items: itemsArray
    }
  };

  options.body = JSON.stringify(options.body);
  return fetch('https://closeapp.mvmtwatches.com/api/warehouses', options)
  // change for test store
  // return fetch('https://closeapp-test.mvmtwatches.com/api/warehouses', options)
  .then(function (res) {
    return res.json();
  }).catch(function (error) {
    return console.log('error', error);
  });
};

// International and domestic collections cart event
InlineCart.addLineItem = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(id, quantity, callback) {
    var warehouseData, warehouseProp;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            warehouseData = [{ variant_id: id, quantity: quantity }];


            if (InlineCart.currentCart.items) {
              InlineCart.currentCart.items.forEach(function (item) {
                warehouseData.push({ variant_id: item.variant_id, quantity: item.quantity });
              });
            }

            _context.next = 4;
            return getWarehouseProp(warehouseData);

          case 4:
            warehouseProp = _context.sent;


            lineItemProperties._center = warehouseProp.warehouses[0].warehouse;

            console.log('warehouseProp', warehouseProp);
            CartJS.addItem(id, quantity, lineItemProperties || {}, {
              success: function success(data, textStatus, jqXHR) {
                // Define a success callback to display a success message.
                InlineCart.getCartHtml();
                openInlineCart();

                if (typeof callback === 'function') {
                  callback();
                }

                // Windsor Cirlce Add to Cart event
                analytics.track('Added Product', {
                  id: id,
                  name: data.product_title,
                  price: data.price,
                  quantity: quantity,
                  cartLink: location.origin + '/cart',
                  value: parseInt(quantity || '0', 10) * parseInt(data.price || '0', 10)
                }, { wcapiVersion: '1.0' });

                // Domestic Dynamic Yield add to cart event
                var DYprice = parseFloat((data.price / 100).toFixed(2));
                DY.API('event', {
                  name: 'Add to Cart',
                  properties: {
                    dyType: 'add-to-cart-v1',
                    value: DYprice, // Total value in actual payment currency, as float (dollars dot cents)
                    currency: 'USD', // Optional non-default currency used
                    productId: data.id.toString(), // SKU exactly as in the product feed!
                    quantity: data.quantity
                  }
                });

                window.juapp = window.juapp || function () {
                  (window.juapp.q = window.juapp.q || []).push(arguments);
                };
                juapp('cartItemAdd', data.id, {
                  name: data.product_title,
                  quantity: data.quantity,
                  price: data.price
                });

                _QuickView2.default.close();
              },
              error: function error(jqXHR, textStatus, errorThrown) {
                // Define an error callback to display an error message.
                window.alert("Sorry, we're unable to do that.\n" + JSON.parse(jqXHR.responseText).description);
              }
            });

            InlineCart.currentCart.items.forEach(function (item) {
              var warehouse = warehouseProp.warehouses.find(function (warehouse) {
                return warehouse.variant_id == item.variant_id;
              });

              if (warehouse) {
                if (!item.properties || item.properties._center != warehouse.warehouse) {
                  console.log('item', item, 'warehouse', warehouse);
                  CartJS.removeItemById(item.variant_id, {
                    success: function success() {
                      CartJS.addItem(item.variant_id, item.quantity, { _center: warehouse.warehouse });
                    }
                  });
                }
              }
            });

          case 9:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

// International only watch pdp cart event
InlineCart.addItems = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(items) {
    var warehouseData, warehouseProp;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (strapPromoActive == true) {
              if (items != undefined) {
                items.forEach(function (item) {
                  item.properties = lineItemProperties;
                });
              }
            }

            warehouseData = items.map(function (_ref3) {
              var id = _ref3.id,
                  quantity = _ref3.quantity;
              return { variant_id: id, quantity: quantity };
            });
            _context2.next = 4;
            return getWarehouseProp(warehouseData);

          case 4:
            warehouseProp = _context2.sent;


            items.forEach(function (item, index) {
              if (!item.properties) {
                item.properties = {};
              }
              item.properties._center = warehouseProp.warehouses[index].warehouse;
            });

            Flow.cart.addItems(items, {
              success: function handleAddToCart(status, cart) {
                InlineCart.getCartHtml();
                openInlineCart();

                // International Dynamic Yield add to cart event
                var addedCount = 0;
                var addedPrice = 0;

                for (var i = 0; i < cart.items.length; i++) {
                  for (var n = 0; n < items.length; n++) {
                    if (cart.items[i].variant_id == items[n].id) {
                      addedCount += items[n].quantity;
                      addedPrice += cart.items[i].local.line_price.amount;
                    }
                  }
                }
                DY.API('event', {
                  name: 'Add to Cart',
                  properties: {
                    dyType: 'add-to-cart-v1',
                    value: addedPrice, // Total value in actual payment currency, as float (dollars dot cents)
                    currency: cart.local.total_price.currency, // Optional non-default currency used
                    productId: items[0].id, // SKU exactly as in the product feed!
                    quantity: addedCount
                  }
                });
              },
              error: function handleAddToCartError(status, error) {
                console.log(error);
              }
            });

          case 7:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function (_x4) {
    return _ref2.apply(this, arguments);
  };
}();

// international and domestic
InlineCart.removeLineItem = function (id, callback) {
  // if (isFlow()) {
  //   Flow.cart.updateItem(id, 0, null, {
  //     error: function(status, error) {
  //       console.log(error);
  //     },
  //   });
  // } else {
  CartJS.updateItemById(id, 0, null, {
    success: function success() {
      if (callback) {
        callback();
      }
    },
    error: function error(jqXHR, textStatus, errorThrown) {
      console.log(errorThrown);
    }
  });
  // }
};

// Function written specifically for DY Test: Free GiftBox Opt out
InlineCart.removeLineItemAndRedirect = function (id, redirectBool) {
  CartJS.updateItemById(id, 0, null, {
    success: function success() {
      if (redirectBool == true) {
        var inlineCartRemovedFreeGiftEvent = $.Event('inline-cart-remove-free-gift-to-checkout');
        $(document).trigger(inlineCartRemovedFreeGiftEvent);
      }
    },
    error: function error(jqXHR, textStatus, errorThrown) {
      console.log(errorThrown);
    }
  });
};

// international and domestic
InlineCart.updateLineItem = function (id, quantity, line_number) {
  CartJS.updateItem(line_number, quantity, null, {
    error: function error(jqXHR, textStatus, errorThrown) {
      console.log('error InlineCart.updateLineItem(' + id + ',' + quantity + ',' + line_number + ');');
      console.log(errorThrown);
    }
  });
};

InlineCart.getCartContents = function () {
  console.log('cart contents');
  InlineCart.getCartHtml();
  InlineCart.getCart();
};

var openInlineCart = function openInlineCart() {
  _Overlay2.default.enable();
  $('.mobile-cart-icon').hide();
  $('.mobile-cart-close-icon').show();
  $('body').addClass('cart-is-active');
  toggleInlineCartVisibilityState(true);
  InlineCart.getCartContents();
};

var closeInlineCart = function closeInlineCart() {
  _Overlay2.default.disable();
  $('.mobile-cart-icon').show();
  $('.mobile-cart-close-icon').hide();
  $('body').removeClass('cart-is-active');
  toggleInlineCartVisibilityState(false);
};

var toggleInlineCart = function toggleInlineCart() {
  if ($('[data-inline-cart]').hasClass('is-active')) {
    closeInlineCart();
  } else {
    openInlineCart();
  }
};

InlineCart.triggerInlineCart = function () {
  if (isFlow()) {
    var options = {
      success: function success(status, cart) {
        InlineCart.freeShipping(cart);
      }
    };

    Flow.cart.getCart(options);
  }
};

window.onFoursixtyCartUpdated = function (cart) {
  $('[data-item-count]').text(cart.item_count);
};

// Event Bindings
var bindUIActions = function bindUIActions() {
  $(document).on('click', '[data-toggle-inline-signin]', function () {
    ViewController.setState({
      account: 'login',
      checkout: ''
    });
  });

  $(document).on('click', '[data-toggle-inline-create-account], [data-inline-register-btn]', function () {
    ViewController.setState({
      account: 'create',
      checkout: ''
    });
  });

  $(document).on('click', '[data-forgot-password-button]', function () {
    ViewController.setState({
      account: 'reset_password',
      checkout: ''
    });
  });

  $(document).on('click', '[data-inline-login-btn]', function () {
    ViewController.setState({
      account: 'login',
      checkout: ''
    });
  });

  $('[data-checkout-path]').on('change', function () {
    var path = $(this).attr('value');

    ViewController.setState({
      account: '',
      checkout: path
    });
  });

  $('[data-inline-cart-header-trigger]').on('click', toggleInlineCart);

  $(document).on('click', '.black-box-pdp-main [add-to-cart]', function () {
    var variantId = $(this).attr('data-variant-id');
    var variantQty = $(this).attr('data-variant-qty');

    InlineCart.addLineItem(variantId, variantQty);
  });

  $(document).on('click', '.the-wall [add-to-cart]', function () {
    var variantId = $(this).attr('data-variant-id');
    var variantQty = $(this).attr('data-variant-qty');

    InlineCart.addLineItem(variantId, variantQty);
  });

  $(document).on('click', '[add-to-cart].js-gg-gc-btn', function () {
    var variantId = $(this).attr('data-variant-id');
    var variantQty = $(this).attr('data-variant-qty');

    InlineCart.addLineItem(variantId, variantQty);
  });

  // $('[data-trigger-mobile-menu]').on('click', function () {
  //   toggleInlineCartVisibilityState(false);
  // });

  $(document).on('click', '.close-cart-img, .btn-continue-shopping', closeInlineCart);
  _Overlay2.default.on('disable', closeInlineCart);

  $(document).on('click', '.product-grid-item [add-to-cart]', function (event) {
    event.preventDefault();
    var variantId = $(this).attr('data-variant-id');
    var variantQty = $(this).attr('data-variant-qty');

    InlineCart.addLineItem(variantId, variantQty);
  });

  $(document).on('change', '[data-line-item-qty]', function () {
    var variantId = $(this).attr('data-line-item-variant-id');
    var variantQty = $(this).val();
    var lineItemNumber = $(this).attr('data-line-item-index');

    InlineCart.updateLineItem(variantId, variantQty, lineItemNumber);
  });

  $(document).on('click', '[data-line-item-remove-btn]', function (e) {
    var variantId = $(this).attr('data-variant-id');

    InlineCart.removeLineItem(variantId);
  });

  // $('.main-cart-block [data-line-item-qty]').on('change', function() {
  //   $(document).on('cart.requestComplete', function(event, cart) {
  //     location.reload();
  //   });
  // });

  $('.main-cart-block [data-line-item-remove-btn]').on('click', function () {
    $(document).on('cart.requestComplete', function (event, cart) {
      location.reload();
    });
  });

  // $(document).on('inline-cart-remove-free-gift-to-checkout', InlineCart.redirectToCheckout);
  // $('[data-guest-checkout-link]').on('click', InlineCart.redirectToCheckout);
};

var generateFlowPromoMessage = function generateFlowPromoMessage(html, numberOfDiscountedItems, productType, both) {
  if (both) {
    html += ' and ';
  }
  html = html + '20% OFF ' + numberOfDiscountedItems + ' ' + productType;
  if (numberOfDiscountedItems > 1) {
    html += 's';
  }
  return html;
};

var displayFlowCartPromoMessage = function displayFlowCartPromoMessage(cart) {
  var numberOfBraceletDiscounts = 0;
  var numberOfStrapDiscounts = 0;
  var html = '';

  if (cart.items != undefined) {
    cart.items.forEach(function (item) {
      if (item.properties) {
        if (item.product_type.indexOf('Bracelet') >= 0 && Object.keys(item.properties).length > 0) {
          numberOfBraceletDiscounts += item.quantity;
        } else if (item.product_type === 'Band' && Object.keys(item.properties).length > 0) {
          numberOfStrapDiscounts += item.quantity;
        }
      }
    });

    if (numberOfBraceletDiscounts > 0 && numberOfStrapDiscounts > 0) {
      html = generateFlowPromoMessage(html, numberOfBraceletDiscounts, 'Bracelet');
      html = generateFlowPromoMessage(html, numberOfStrapDiscounts, 'Strap', true);
    } else if (numberOfBraceletDiscounts > 0) {
      html = generateFlowPromoMessage(html, numberOfBraceletDiscounts, 'Bracelet');
    } else if (numberOfStrapDiscounts > 0) {
      html = generateFlowPromoMessage(html, numberOfStrapDiscounts, 'Strap');
    }

    $('[data-flow-promo-message]').empty();
    if (html.length > 0) {
      $('[data-flow-promo-message]').append('<div class="bracelet-promo-bar--show bracelet-promo-bar--collection">' + html + '</div>');
    }
  }
};

var checkLimitedEdition = function checkLimitedEdition(cart) {
  var limitedEditionId = 12680388870226;
  var limitedEditionCount = 0;

  if (cart.items != undefined) {
    cart.items.forEach(function (item, i) {
      if (item.id === limitedEditionId) {
        if (item.quantity > 1) {
          alert('Limit One Per Order\nDue to the special nature of this product, purchases are limited to one per order. You may order another item in a subsequent order.');
          InlineCart.updateLineItem(limitedEditionId, 1, i + 1);
        }
      }
    });
  }
};

var _getLineItemsContainerHeight = exports._getLineItemsContainerHeight = function _getLineItemsContainerHeight() {
  var consumedHeight = 0;
  var inlineCartHeight = $('[data-inline-cart]').height();

  $('[data-inline-cart] > *:not([data-cart-contents])').each(function () {
    var $el = $(this);

    if ($el.is(':visible')) {
      consumedHeight += $el[0].scrollHeight;
    }
  });

  return inlineCartHeight - consumedHeight;
};

var ViewController = exports.ViewController = {
  checkout: {
    state: 'guest',
    options: ['guest', 'account'],
    selectors: {
      guest: '[data-guest-checkout-link]',
      account: '[data-inline-account-buttons]'
    }
  },
  account: {
    state: '',
    options: ['create', 'login', 'reset_password'],
    selectors: {
      create: '[data-inline-register-form]',
      login: '[data-inline-login-form]',
      reset_password: '[data-inline-forgot-password-form]'
    }
  },

  /**
   *
   * @param {Object} object
   * @returns {Object}
   */
  _updateByObject: function _updateByObject(object) {
    var transitions = {
      out: [],
      in: []
    };

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = object.options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var option = _step.value;

        if (object.state !== option) {
          transitions.out.push($(object.selectors[option]));
        } else {
          transitions.in.push($(object.selectors[option]));
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return transitions;
  },
  _updateUI: function _updateUI() {
    var updateObjects = [];
    var heightAdjusted = false;

    var _arr = ['checkout', 'account'];
    for (var _i = 0; _i < _arr.length; _i++) {
      var key = _arr[_i];
      updateObjects.push(this._updateByObject(this[key]));
    }

    var transitioningOut = updateObjects.reduce(function (acc, cur) {
      return [].concat((0, _toConsumableArray3.default)(acc), (0, _toConsumableArray3.default)(cur.out));
    }, []);
    var transitioningIn = updateObjects.reduce(function (acc, cur) {
      return [].concat((0, _toConsumableArray3.default)(acc), (0, _toConsumableArray3.default)(cur.in));
    }, []);

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = transitioningOut[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var $el = _step2.value;

        $el.slideUp(300);
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = transitioningIn[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var _$el = _step3.value;

        _$el.slideDown(300, function completeSlideIn() {
          // dont do unnecessary layout calculations
          if (!heightAdjusted) {
            $('[data-cart-contents]').css('max-height', _getLineItemsContainerHeight());
            heightAdjusted = !heightAdjusted;
          }
        });
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }
  },
  setState: function setState(_ref4) {
    var account = _ref4.account,
        checkout = _ref4.checkout;

    this.account.state = account;
    this.checkout.state = checkout;

    console.log('account', account);
    console.log('checkout', checkout);

    this._updateUI();
  }
};

InlineCart.ViewController = ViewController;

// Used in inline cart account test, included here to exclude from Flow experiences
function inlineCartTestBindings() {
  /*
  function scrollInlineCart() {
    var headerHeight = $('.header-main').outerHeight();
    var cartContentsHeight = $('.line-item-container').outerHeight();
    $('.inline-cart')
      .delay(200)
      .animate(
        {
          scrollTop: cartContentsHeight - headerHeight + $('.shipping-header').outerHeight(),
        },
        500,
      );
  }
   if (window.dyGiftBoxTestActive) {
    $(document).on('click', '[data-guest-checkout-link], .btn-checkout, [kind="facebook"], [kind="google"]', function(event) {
      checkoutRemoveFreeGift(event);
    });
  } else {
    if (isFlow()) {
      $(document).on('click', '[data-guest-checkout-link], .btn-checkout, [kind="facebook"], [kind="google"]', function(event) {
        event.preventDefault();
        Flow.cart.redirectToCheckout();
      });
    }
  }
   $(document).on('submit', '[data-login-inline] form#customer_login', function(event) {
    if (customerRemovedFreeGift == false) {
      const goldGiftBoxId = 27492865929;
      const blackGiftBoxId = 13099142217810;
       if ($('#get-free-box-checkbox-27492865929').prop('checked') == false && $('#get-free-box-checkbox-13099142217810').prop('checked') == false) {
        event.preventDefault();
        InlineCart.removeLineItem(goldGiftBoxId);
        InlineCart.removeLineItem(blackGiftBoxId);
        customerRemovedFreeGift = true;
        $(this).submit();
      } else if ($('#get-free-box-checkbox-27492865929').prop('checked') == false) {
        event.preventDefault();
        InlineCart.removeLineItem(goldGiftBoxId);
        customerRemovedFreeGift = true;
        $(this).submit();
      } else if ($('#get-free-box-checkbox-13099142217810').prop('checked') == false) {
        event.preventDefault();
        InlineCart.removeLineItem(blackGiftBoxId);
        customerRemovedFreeGift = true;
        $(this).submit();
      }
    }
  });
  */
}

InlineCart.redirectToCheckout = function (e) {
  if (e && e instanceof $.Event) {
    e.preventDefault();
    e.stopPropagation();
  }
  if (isFlow()) {
    Flow.checkout.redirect();
  } else {
    window.location.href = '/checkout';
  }
};

var checkForRedirectToCheckoutHash = function checkForRedirectToCheckoutHash() {
  if (window.location.hash && window.location.hash == '#checkout') {
    Flow.set('on', 'ready', function () {
      InlineCart.redirectToCheckout();
    });
  }
};

// init functions
InlineCart.init = function () {
  lineItemEntryPoint = $('[data-cart-contents]');
  _Overlay2.default.init();
  // bindUIActions();
  inlineCartTestBindings();
  checkForRedirectToCheckoutHash();

  InlineCart.getCartContents();
  $(document).on('cart.requestComplete', function (event, cart) {
    InlineCart.getCartContents();
    if (window.dyCartUpsellTest) {
      InlineCartRecs.serveUpsell(cart);
    }
    checkLimitedEdition(cart);
  });

  // 2019 Valentines Day
  // InlineCart.removeLineItem(13100117000274);

  ViewController._updateUI();
};

window.InlineCart = InlineCart;

ViewController._updateUI();